import React from "react";

export const OPEN_ABOUT_DIALOG = "aboutContext/showAboutDialog";
export const CLOSE_ABOUT_DIALOG = "aboutContext/closeAboutDialog";

const AboutStateContext = React.createContext(undefined);
const AboutDispatchContext = React.createContext(undefined);

const initialState = {
    open: false,
};

const aboutReducer = (state, action) => {
    console.debug('about reducer', action);
    switch (action.type) {
        case OPEN_ABOUT_DIALOG:
            return {
                ...state,
                open: true,
            };
        case CLOSE_ABOUT_DIALOG:
            return {
                ...state,
                open: false,
            };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};

export const AboutProvider = ({children}) => {
    const [state, dispatch] = React.useReducer(
        aboutReducer,
        {...initialState},
        undefined
    );

    return (
        <AboutStateContext.Provider value={state}>
            <AboutDispatchContext.Provider value={dispatch}>
                {children}
            </AboutDispatchContext.Provider>
        </AboutStateContext.Provider>
    );
};

export const useAboutState = () => {
    const context = React.useContext(AboutStateContext);
    if (undefined === context) {
        throw new Error("useAboutState must be used within a AboutProvider");
    } else {
        return context;
    }
};

export const useAboutDispatch = () => {
    const context = React.useContext(AboutDispatchContext);
    if (undefined === context) {
        throw new Error(
            "useAboutDispatch must be used within a AboutProvider"
        );
    } else {
        return context;
    }
};
